import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { httpInterceptorProviders } from './http-interceptors';

@NgModule({
  imports: [CommonModule],
  providers: httpInterceptorProviders,
})
export class SharedDataAccessFlamingoModule {}
